import axios from 'axios';

import { outboundLog, inboundLog } from '@/utils/Logger';

const axiosInstance = axios.create({ baseURL: `${process.env.REACT_APP_API_URL}/fo` });

const token = localStorage.getItem('@token');
if (token) {
  axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// Request intercept
axiosInstance.interceptors.request.use(
  (config) => {
    outboundLog('API', { method: config.method, url: config.url });
    return config;
  },
  (error) => Promise.reject(error)
);
// Response intercept
axiosInstance.interceptors.response.use(
  ({ data, headers }) => {
    // Returns { headers, data } instead of processed data when handling blob
    if (data instanceof Blob) {
      return { headers, data };
    }

    // Invalid access token
    if (!data.success && data.data.code === 4001) {
      removeAuthToken();
      window.location.replace('/');

      return { success: false };
    }

    inboundLog('API', data, data.success);
    return data; // Returns processed API response data directly
  },
  (error) => {
    return {
      success: false,
      data: { error },
    };
  }
);

export default axiosInstance;

export const setAuthToken = (newToken) => {
  axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
  localStorage.setItem('@token', newToken);
};

export const getAuthToken = () => {
  return localStorage.getItem('@token');
};

export const removeAuthToken = () => {
  delete axiosInstance.defaults.headers.common['Authorization'];
  localStorage.removeItem('@token');
};
